import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container, Card, CardBody,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import { Package, BarChart2, Activity } from 'react-feather';
import classnames from 'classnames';
import http from '../../components/network';

import SummaryCards from './components/SummaryCards';
import StockOnHand from './tabs/StockOnHand';
import StockCard from './tabs/StockCard';
import Movements from './tabs/Movements';

const InventoryPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('stock-on-hand');
  const [summary, setSummary] = useState(null);
  const [loadingSummary, setLoadingSummary] = useState(false);

  const fetchSummary = async () => {
    setLoadingSummary(true);
    try {
      const response = await http.get('/inventory/summary');
      setSummary(response.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    } finally {
      setLoadingSummary(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const tabs = [
    { id: 'stock-on-hand', label: t('Stock on Hand'), icon: <Package size={15} /> },
    { id: 'stock-card', label: t('Kartu Stok'), icon: <BarChart2 size={15} /> },
    { id: 'movements', label: t('Mutasi Stok'), icon: <Activity size={15} /> },
  ];
  return (
    <Container fluid className="py-3">

      {/* ============ PAGE HEADER ============ */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fw-bold mb-1" style={{ color: '#1e293b' }}>
            {t('Inventory Management')}
          </h3>
          <p className="text-muted small mb-0">
            {t('Manage stock, batch, and movements stock')}
          </p>
        </div>
      </div>

      {/* ============ SUMMARY CARDS ============ */}
      <SummaryCards summary={summary} loading={loadingSummary} />

      {/* ============ TAB BAR (CARD TERPISAH) ============ */}
      <Card
        className="shadow-sm border-0 mt-4"
        style={{ borderRadius: '12px 12px 0 0', marginBottom: 0 }}
      >
        <CardBody className="p-0">
          <Nav
            tabs
            className="inventory-tabs"
            style={{
              borderBottom: 'none',
              padding: '8px 16px 0 16px',
              gap: '4px',
            }}
          >
            {tabs.map((tab) => (
              <NavItem key={tab.id}>
                <NavLink
                  className={classnames({ active: activeTab === tab.id })}
                  onClick={() => toggleTab(tab.id)}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderRadius: '8px 8px 0 0',
                    padding: '10px 18px',
                    fontWeight: 600,
                    fontSize: '13px',
                    color: activeTab === tab.id ? '#1e293b' : '#64748b',
                    background: activeTab === tab.id ? '#fff' : 'transparent',
                    border: 'none',
                    borderBottom: activeTab === tab.id ? '2px solid #0ea5e9' : '2px solid transparent',
                    transition: 'all 0.15s ease',
                  }}
                >
                  {tab.icon}
                  {tab.label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </CardBody>
      </Card>

      {/* ============ TAB CONTENT (CARD TERPISAH) ============ */}
      <Card
        className="shadow-sm border-0"
        style={{ borderRadius: '0 0 12px 12px', marginTop: 0 }}
      >
        <CardBody className="p-4">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="stock-on-hand">
              {activeTab === 'stock-on-hand' && <StockOnHand />}
            </TabPane>
            <TabPane tabId="stock-card">
              {activeTab === 'stock-card' && <StockCard />}
            </TabPane>
            <TabPane tabId="movements">
              {activeTab === 'movements' && <Movements />}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>

      {/* ============ CUSTOM STYLE ============ */}
      <style>{`
        .inventory-tabs .nav-link {
          border: none !important;
          background: transparent;
        }
        .inventory-tabs .nav-link:hover {
          color: #1e293b !important;
          background: #f1f5f9 !important;
          border-radius: 8px 8px 0 0;
        }
        .inventory-tabs .nav-link.active {
          background: #fff !important;
        }
        .inventory-tabs .nav-link.active::after {
          content: '';
        }
      `}</style>

    </Container>
  );
};

export default InventoryPage;